export default {
  movieList: (state, getters) => {
    return state.movieList
  },
  movieImage: (state, getters) => {
    const imageUrl = getters.selectedMovie.ImageUrl;
    return (imageUrl && imageUrl.includes('.') && imageUrl) ||
      `https://pruneyardcinemas.com/wp-content/uploads/2019/11/default-image.jpg`
  },
  selectedMovie: (state, getters) => {
    return state.selectedMovie
  },
  availableDateRange: (state, getters) => {
    return state.availableRange;
  },
  availableTimes: (state) => {
    return state.availableTimes;
  },
  availableDays: (state) => {
    return state.availableDays;
  }
}
